import { GarageTable } from 'components/Tables/GarageTable';
import { StorageTable } from 'components/Tables/StorageTable';
import React from 'react';
import { GarageListMobile } from 'sections/GarageListMobile/GarageListMobile';
import {
    Wrapper,
    SectionTitleWrapper,
    TableStorageWrapper,
    TableWrapper,
    StyledButton,
    TableGarageWrapper,
    SectionTitle,
} from './GaragesAndStoragesList.styled';
import { useBreakpoint } from 'utils/hooks/useBreakpoints';
import { StorageListMobile } from 'sections/StorageListMobile/StorageListMobile';
import { SingleGarageType, SingleStorageRoomType } from 'types/CommonTypes';
import { StorageInfo } from 'sections/StorageInfo/StorageInfo';

interface GaragesAndStoragesListProps {
    additionalInfo: string;
    garagesData: SingleGarageType[];
    hideStoragesMap: boolean;
    investmentSlug: string;
    storagesData: SingleStorageRoomType[];
}

export const GaragesAndStoragesList = ({
    additionalInfo,
    garagesData,
    hideStoragesMap,
    investmentSlug,
    storagesData,
}: GaragesAndStoragesListProps) => {
    const isMobile = useBreakpoint('sm');
    return (
        <Wrapper>
            {hideStoragesMap && <StorageInfo text={additionalInfo} />}
            <SectionTitleWrapper>
                <SectionTitle>Garaże</SectionTitle>
                <StyledButton to={'/' + investmentSlug + '/mieszkania'}>
                    Zobacz mieszkania
                </StyledButton>
            </SectionTitleWrapper>
            {!isMobile && (
                <TableGarageWrapper hideStoragesMap={hideStoragesMap}>
                    <TableWrapper>
                        <GarageTable data={garagesData} />
                    </TableWrapper>
                </TableGarageWrapper>
            )}
            {isMobile && (
                <GarageListMobile
                    data={garagesData}
                    investmentSlug={investmentSlug}
                />
            )}
            {!hideStoragesMap && (
                <SectionTitleWrapper>
                    <SectionTitle>Komórki lokatorskie</SectionTitle>
                    <StyledButton to={'/' + investmentSlug + '/mieszkania'}>
                        Zobacz mieszkania
                    </StyledButton>
                </SectionTitleWrapper>
            )}
            {isMobile && !hideStoragesMap && (
                <StorageListMobile
                    data={storagesData}
                    investmentSlug={investmentSlug}
                />
            )}
            {!hideStoragesMap && (
                <TableStorageWrapper>
                    <TableWrapper>
                        <StorageTable data={storagesData} />
                    </TableWrapper>
                </TableStorageWrapper>
            )}
        </Wrapper>
    );
};
